<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="title">
        <div class="container">
          <div class="type">
            <button class="btn" :class="{active: !type}" @click="onType(0)">雇主</button>
            <button class="btn" :class="{active: type}" @click="onType(1)">制作人</button>
          </div>
          <div class="state">
            <a href="javascript:void(0);" :class="{active: state == 1}" @click="onState(1)">进行中</a>
            <a href="javascript:void(0);" :class="{active: state == 2}" @click="onState(2)">已完成</a>
            <a href="javascript:void(0);" :class="{active: state == 3}" @click="onState(3)">已关闭</a>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="container">
          <div class="empty" v-if="(!type && !partyAList.length) || (type && !partyBList.length)">暂无项目</div>
          <div class="list" v-if="!type">
            <div class="item" v-for="item in partyAList">
              <div class="order-no">订单编号：{{item.projectNo}}<span style="margin-left: 20px;">项目名称：{{item.projectName}}</span></div>
              <div class="order-info clearfix">
                <div>
                  <div>影片类型</div>
                  <div>{{item.typeStr}}</div>
                </div>
                <div>
                  <div>要求成片时间</div>
                  <div>{{item.endTime|formatDate}}</div>
                </div>
                <div>
                  <div>影片时长</div>
                  <div>{{item.length|length}}</div>
                </div>
                <div>
                  <div>项目预算</div>
                  <div>{{item.budget|budget}}</div>
                </div>
                <div>
                  <div>发布时间</div>
                  <div>{{item.addTime|formatDate}}</div>
                </div>
                <div>
                  <div>项目状态</div>
                  <div v-if="!(item.operatorStatus == 4 || item.isClosed)" >{{item.status|ppaType}}</div>
                  <div v-if="item.operatorStatus == 4 || item.isClosed">已关闭</div>
                </div>
                <div>
                  <a :href="'projectPartyA.html?id='+item.id" target="_blank" class="btn btn-default">查看详情</a>
                </div>
              </div>
            </div>
          </div>

          <div class="list" v-if="type">
            <div class="item" v-for="item in partyBList">
              <div class="order-no">订单编号：{{item.projectNo}}<span style="margin-left: 20px;">项目名称：{{item.projectName}}</span></div>
              <div class="order-info clearfix">
                <div>
                  <div>影片类型</div>
                  <div>{{item.typeStr}}</div>
                </div>
                <div>
                  <div>要求成片时间</div>
                  <div>{{item.endTime|formatDate}}</div>
                </div>
                <div>
                  <div>影片时长</div>
                  <div>{{item.length|length}}</div>
                </div>
                <div>
                  <div>项目预算</div>
                  <div>{{item.budget|budget}}</div>
                </div>
                <div>
                  <div>发布时间</div>
                  <div>{{item.addTime | formatDate}}</div>
                </div>
                <div>
                  <div>项目状态</div>
                  <div>{{item.accessStatus}}</div>
                </div>
                <div>
                  <a :href="'projectAccept.html?id='+item.id" v-if="item.status<14"target="_blank" class="btn btn-default">查看详情</a>
                  <a :href="'projectPartyB.html?id='+item.id" v-if="item.status>13" target="_blank" class="btn btn-default">查看详情</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pages">
        <div class="container">
          <Page :total="total" :page-size="pageSize" @on-change="pagesChange" :current="currPage"></Page>
        </div>
      </div>

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'
  import { projectApi,apiReg } from '@/fetch/api';

  export default {
    components:{
      Header,Footer
    },
    data(){
      return{
        total:0,
        pageSize: 10, //每页条数
        currPage: 1, //当前页数
        partyAList: [],
        partyBList: [],
        user:"",
        type: 0, //0雇主 1制片
        state: 1 //1进行 2完成 3关闭
      }
    },
    mounted(){
      this.user = JSON.parse(localStorage.getItem('userInfo'))
      if(!this.user){
        location.href = 'index.html';
        return;
      }

      this.getPartyAList();
    },
    methods:{
      onType(val){
        this.type = val;
        this.state = 1;
        this.currPage = 1;

        if(val){
          this.getPartyBList();
        } else {
          this.getPartyAList();
        }
      },
      onState(val){
        this.state = val;
        this.currPage = 1;

        if(this.type){
          this.getPartyBList();
        } else {
          this.getPartyAList();
        }
      },
      pagesChange(no){
        this.currPage = no;

        if(this.type){
          this.getPartyBList();
        } else {
          this.getPartyAList();
        }
      },
      getPartyAList(){
        let params = {
          "accessStatus": this.state,
          "pageNo": this.currPage,
          "pageSize": this.pageSize
        }

        projectApi.getConsumerIntentionList(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }

          this.partyAList = re.list?re.list:[];
          this.total = re.counts;
        });
      },
      getPartyBList(){
        let params = {
          "accessStatus": this.state,
          "pageNo": this.currPage,
          "pageSize": this.pageSize
        }

        projectApi.apiProducerGetConsumerIntentionList(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }

          this.partyBList = re.list?re.list:[];
          this.total = re.counts;
        });
      }
    }
  }
</script>

<style scoped>
  .title{ padding: 30px 0 30px; background: #ffffff;}
  .title .type{ text-align: center;}
  .title .type .btn{ margin-right: 30px; padding: 5px 0; width: 80px; color: #424753; background: #F2F2F2;}
  .title .type .btn:last-child{ margin-right: 0;}
  .title .type .btn.active{ color: #ffffff; background: #3E87FF; box-shadow: 0 4px 10px 0 rgba(92,141,222,0.60);}
  .title .state{ margin-top: 20px; padding: 8px 0; text-align: center;}
  .title .state a{ margin-right: 60px; color: #424753;}
  .title .state a.active{ color: #3E87FF;}
  .title .state a:last-child{ margin-right: 0;}
  .content{ min-height: 800px;}
  .list .item{ margin-top: 30px; color: #424753;}
  .list .item .order-no{ margin-bottom: 15px; color: #838895;}
  .list .item .order-info{ padding: 30px 20px; background: #ffffff;}
  .list .item .order-info>div{ float: left;}
  .list .item .order-info>div:nth-child(1){ width: 126px;}
  .list .item .order-info>div:nth-child(2){ width: 161px;}
  .list .item .order-info>div:nth-child(3){ width: 135px;}
  .list .item .order-info>div:nth-child(4){ width: 195px;}
  .list .item .order-info>div:nth-child(5){ width: 220px;}
  .list .item .order-info>div:nth-child(6){ width: 213px;}
  .list .item .order-info>div:nth-child(7){ width: 110px;}
  .list .item .order-info>div>div:nth-child(1){ color: #424753;}
  .list .item .order-info>div>div:nth-child(2){ margin-top: 10px; font-size: 16px; font-weight: 600;}
  .list .item .order-info .btn{ margin-top: 11px; padding: 6px 0; width: 110px; font-size: 12px;}
  .pages{ padding: 60px 0; text-align: center;}
  .empty{ padding: 100px 0; font-size: 30px; text-align: center;}
</style>



// WEBPACK FOOTER //
// App.vue?360cae64